import React, { useRef, useEffect } from "react";
import L from "leaflet";
import { Marker, Tooltip } from "react-leaflet";
import { DefaultTemplate } from "../../_helpers";

export function ImageMarker({
  marker,
  template,
  methods,
  editMode = false,
  innerRef,
}) {
  if (!marker) {
    return null;
  }
  const { coords } = marker;

  const markerRef = innerRef ? innerRef : useRef();

  const cssClasses = ["chronos-map-marker", `chronos-marker-${marker._id}`];
  const prefix = `https://www.worldanvil.com/`;
  const combinedTemplate = parseMarkerDisplay(marker, template);
  const { pinImg, width, height, anchorX, anchorY, primaryColor, filter } =
    combinedTemplate;
  // console.log("Marker Template", combinedTemplate);
  if (combinedTemplate.customClassName.length > 0) {
    combinedTemplate.customClassName.split(" ").forEach((className) => {
      cssClasses.push(className);
    });
  }
  const icon = L.icon({
    iconUrl: `${prefix}${pinImg.path}`,
    iconSize: [width, height],
    iconAnchor: [anchorX, anchorY],
    className: cssClasses.join(" "),
  });

  const tooltipOffset = [width / 2 - anchorX, -height - (anchorY - height)];

  useEffect(() => {
    if (markerRef && markerRef.current) {
      if (typeof primaryColor === "string" && primaryColor !== "") {
        if (typeof filter === "string" && filter !== "") {
          // console.log('Setting Marker style!');
          const el = markerRef.current.getElement();
          el.style.filter = filter;
        }
      }
    }
  }, [template]);

  return (
    <Marker
      position={[coords.y, coords.x]}
      icon={icon}
      className="chronos-map-marker"
      // eventHandlers={{ ...methods, add: handleAdd }}
      eventHandlers={{ ...methods }}
      draggable={editMode}
      ref={markerRef}
    >
      {combinedTemplate.tooltipEnabled && (
        <Tooltip direction="top" offset={tooltipOffset}>
          {marker.title}
        </Tooltip>
      )}
    </Marker>
  );
}

function parseMarkerDisplay(marker, template) {
  const combinedTemplate = new DefaultTemplate();
  // console.log('DefaultTemplate', combinedTemplate);

  const parserKeys = Object.keys(new DefaultTemplate()).filter((key) => {
    return key !== "pinImg";
  });

  const { templateOverrides } = { ...marker };

  for (let i = 0; i < parserKeys.length; i++) {
    const key = parserKeys[i];
    if (templateOverrides.hasOwnProperty(key) && template.hasOwnProperty(key)) {
      if (combinedTemplate[key] !== templateOverrides[key]) {
        combinedTemplate[key] = templateOverrides[key];
      } else {
        if (
          template &&
          template.hasOwnProperty(key) &&
          template[key] !== combinedTemplate[key]
        ) {
          combinedTemplate[key] = template[key];
        }
      }
    }
  }

  const { pinImg: overrideImage } = templateOverrides;
  const defaultPath = combinedTemplate.pinImg.path;
  if (overrideImage !== null && overrideImage.path !== defaultPath) {
    Object.assign(combinedTemplate.pinImg, overrideImage);
  } else {
    if (template && typeof template !== "string" && template !== null) {
      if (
        template.pinImg &&
        template.pinImg.path &&
        template.pinImg.path !== defaultPath
      ) {
        Object.assign(combinedTemplate.pinImg, template.pinImg);
      }
    }
  }
  // console.log('FULL TEMPLATE', combinedTemplate);
  return combinedTemplate;
}
